import $ from 'jquery';
import Api from '../util/Api';
import Popup from '../util/Popup';

$('.js-referral-stats').click(function (e) {
    Popup.showWithContent('<h2>Loading...</h2>', 300);
    Api.post('/api/referral-stats/counts/', { id: $(this).attr('data-id') }).then((response) => {
        Popup.showWithTitle('Referral link statistics', response, 300);
    });
});

$('body').on('click', '.js-referral-stats-detail', function (e) {
    Popup.showWithContent('<h2>Loading...</h2>', 200);
    Api.post('/api/referral-stats/detail/', { id: $(this).attr('data-id') }).then((response) => {
        Popup.showWithTitle('Referral link detailed statistics', response, 1200);
    });
});
